import { useEffect } from 'react';

export default function StructuredData() {
  useEffect(() => {
    const localBusinessSchema = {
      '@context': 'https://schema.org',
      '@type': 'MovingCompany',
      name: 'umzug-schweiz-deutschland.ch - Umzugsfirma nach Deutschland',
      alternateName: 'Umzug Schweiz Deutschland',
      description: 'Professionelle Umzugsfirma nach Deutschland für Umzug Schweiz Deutschland und Auswandern nach Deutschland. Spezialisiert auf internationale Umzüge mit Zollabwicklung, Transport & Montage.',
      url: 'https://umzug-schweiz-deutschland.ch',
      telephone: '0800700100',
      email: 'info@umzugprofis.ch',
      address: {
        '@type': 'PostalAddress',
        addressCountry: 'CH',
        addressLocality: 'Zürich',
      },
      areaServed: [
        {
          '@type': 'Country',
          name: 'Switzerland',
        },
        {
          '@type': 'Country',
          name: 'Germany',
        },
      ],
      priceRange: 'CHF 3900-7900',
      openingHoursSpecification: [
        {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
          opens: '07:00',
          closes: '19:00',
        },
        {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: 'Saturday',
          opens: '08:00',
          closes: '16:00',
        },
      ],
      knowsAbout: ['Umzug nach Deutschland', 'Umzug Schweiz Deutschland', 'Auswandern nach Deutschland', 'Umzugsfirma nach Deutschland', 'Internationale Umzüge'],
    };

    const faqSchema = {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: [
        {
          '@type': 'Question',
          name: 'Was kostet ein Umzug von der Schweiz nach Deutschland?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Die Kosten hängen vom Volumen, der Distanz und den gewünschten Zusatzleistungen ab. Ein 2-Zimmer-Umzug beginnt ab ca. CHF 3\'900.–, ein 3-Zimmer-Umzug ab ca. CHF 5\'900.– und ein 4-Zimmer-Umzug ab ca. CHF 7\'900.–.',
          },
        },
        {
          '@type': 'Question',
          name: 'Welche Zollformalitäten muss ich beachten?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Beim Umzug in ein anderes Land müssen Ausfuhr- und Einfuhrdokumente erstellt werden. Wir übernehmen die gesamte Zollabwicklung inklusive aller notwendigen Unterlagen für Sie.',
          },
        },
        {
          '@type': 'Question',
          name: 'Wie lange dauert ein Umzug Schweiz → Deutschland?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Je nach Entfernung und Umfang dauert der Transport zwischen 1 und 3 Tagen. Inklusive Zollabwicklung wird der Zeitplan individuell auf Ihren Umzug abgestimmt.',
          },
        },
        {
          '@type': 'Question',
          name: 'Kann ich auch nur Möbel transportieren lassen?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Ja. Wir bieten Teilumzüge und reine Möbeltransporte an – ideal für einzelne Möbelstücke, Kartons oder Teilhaushalte.',
          },
        },
        {
          '@type': 'Question',
          name: 'Bieten Sie Verpackungsmaterial an?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Ja. Wir liefern auf Wunsch stabile Umzugskartons, Kleiderboxen, Luftpolsterfolie und spezielles Verpackungsmaterial für empfindliche Gegenstände.',
          },
        },
        {
          '@type': 'Question',
          name: 'Übernehmen Sie die Zollabwicklung?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Ja, wir kümmern uns um die komplette Zollabwicklung, sodass Sie sich um nichts kümmern müssen.',
          },
        },
        {
          '@type': 'Question',
          name: 'Welche Unterlagen brauche ich für den Zoll?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Üblicherweise benötigen Sie eine detaillierte Inventarliste, Kopie der Ausweise und ggf. Miet- oder Kaufvertrag der neuen Wohnung. Wir stellen Ihnen eine Checkliste bereit.',
          },
        },
        {
          '@type': 'Question',
          name: 'Kann ich auch kurzfristig einen Umzug buchen?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Ja, je nach Kapazität können wir auch kurzfristige Umzüge durchführen. Kontaktieren Sie uns frühzeitig für eine schnelle Abklärung.',
          },
        },
        {
          '@type': 'Question',
          name: 'Führen Sie auch Firmenumzüge Schweiz → Deutschland durch?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Ja. Wir organisieren Firmenumzüge, Büroumzüge und Mitarbeiterumzüge inklusive Möbelabbau, Transport und Wiederaufbau am Zielort.',
          },
        },
        {
          '@type': 'Question',
          name: 'Gibt es Zwischenlagerungen in der Schweiz oder Deutschland?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Ja, wir bieten sichere Zwischenlager in der Schweiz und Deutschland an, wenn der Einzugstermin noch nicht feststeht.',
          },
        },
        {
          '@type': 'Question',
          name: 'Bieten Sie auch Endreinigung in der alten Wohnung an?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Ja, wir übernehmen auf Wunsch eine professionelle Endreinigung mit Abnahmegarantie für Ihre alte Wohnung.',
          },
        },
        {
          '@type': 'Question',
          name: 'Sind meine Möbel versichert?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Ja. Ihr Umzugsgut ist während des Transports und der Lagerung gemäss unseren Versicherungsbedingungen abgesichert.',
          },
        },
        {
          '@type': 'Question',
          name: 'Kann ich beim Umzug selbst mithelfen, um Kosten zu sparen?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Ja. Sie können Eigenleistungen wie Verpacken oder Tragen übernehmen. Dadurch reduzieren sich die Gesamtkosten.',
          },
        },
        {
          '@type': 'Question',
          name: 'Transportieren Sie auch heikle Güter (Klavier, Kunst, Maschinen)?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Ja. Wir haben Erfahrung mit Spezialtransporten wie Klavieren, Kunstwerken oder technischen Geräten und setzen dafür spezielle Hilfsmittel ein.',
          },
        },
        {
          '@type': 'Question',
          name: 'Welche Regionen in Deutschland decken Sie ab?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Wir fahren regelmässig nach München, Berlin, Hamburg, Stuttgart, Frankfurt, Köln und in alle weiteren Regionen Deutschlands.',
          },
        },
        {
          '@type': 'Question',
          name: 'Haben Sie Erfahrung mit Grenzumzügen?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Ja, wir sind spezialisiert auf Grenzumzüge und kennen die Zollformalitäten sowie die notwendigen Abläufe im Detail.',
          },
        },
        {
          '@type': 'Question',
          name: 'Gibt es einen Festpreis oder Stundenansatz?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Wir bieten beides an: transparente Stundenpreise oder Fixpreis-Offerten nach Besichtigung. So haben Sie volle Kostenkontrolle.',
          },
        },
        {
          '@type': 'Question',
          name: 'Muss ich beim Zoll anwesend sein?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'In den meisten Fällen genügt es, wenn wir die Unterlagen in Ihrem Namen einreichen. Nur bei speziellen Fällen ist Ihre Anwesenheit nötig.',
          },
        },
        {
          '@type': 'Question',
          name: 'Übernehmen Sie die Möbelmontage am Zielort?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Ja, wir bauen Ihre Möbel in der alten Wohnung ab, transportieren sie und montieren sie am Zielort wieder professionell.',
          },
        },
        {
          '@type': 'Question',
          name: 'Gibt es einen kostenlosen Besichtigungstermin?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Ja. Wir bieten kostenlose Besichtigungen vor Ort oder virtuell per Video-Call an, um ein exaktes Angebot erstellen zu können.',
          },
        },
        {
          '@type': 'Question',
          name: 'Was muss ich beim Auswandern nach Deutschland beachten?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Beim Auswandern nach Deutschland müssen Sie sich in der Schweiz abmelden, in Deutschland anmelden, Zolldokumente vorbereiten und ggf. Arbeits- und Aufenthaltserlaubnis organisieren. Wir unterstützen Sie bei der Umzugsplanung und Zollabwicklung.',
          },
        },
        {
          '@type': 'Question',
          name: 'Welche Umzugsfirma ist am besten für Umzug nach Deutschland?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Eine gute Umzugsfirma nach Deutschland sollte Erfahrung mit internationalen Umzügen haben, Zollabwicklung anbieten und transparente Preise garantieren. Wir sind spezialisiert auf Umzug Schweiz Deutschland mit über 2000 erfolgreichen Umzügen.',
          },
        },
        {
          '@type': 'Question',
          name: 'Wie lange dauert Auswandern nach Deutschland?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Der physische Umzug dauert 1-3 Tage. Die gesamte Auswanderungsplanung mit Behördengängen, Zollanmeldung und Wohnungssuche sollten Sie 2-3 Monate im Voraus beginnen. Wir koordinieren den Umzugsteil für Sie.',
          },
        },
        {
          '@type': 'Question',
          name: 'Was kostet eine Umzugsfirma nach Deutschland?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'Die Kosten für eine professionelle Umzugsfirma nach Deutschland beginnen ab CHF 3\'900 für einen 2-Zimmer-Umzug. Der Preis hängt von Volumen, Distanz und gewünschten Services ab. Wir erstellen Ihnen eine kostenlose Offerte.',
          },
        },
      ],
    };

    const script1 = document.createElement('script');
    script1.type = 'application/ld+json';
    script1.text = JSON.stringify(localBusinessSchema);
    document.head.appendChild(script1);

    const script2 = document.createElement('script');
    script2.type = 'application/ld+json';
    script2.text = JSON.stringify(faqSchema);
    document.head.appendChild(script2);

    const aggregateRatingSchema = {
      '@context': 'https://schema.org',
      '@type': 'LocalBusiness',
      name: 'umzug-schweiz-deutschland.ch',
      aggregateRating: {
        '@type': 'AggregateRating',
        ratingValue: '4.9',
        bestRating: '5',
        worstRating: '1',
        ratingCount: '247',
      },
    };

    const script3 = document.createElement('script');
    script3.type = 'application/ld+json';
    script3.text = JSON.stringify(aggregateRatingSchema);
    document.head.appendChild(script3);

    const serviceSchema = {
      '@context': 'https://schema.org',
      '@type': 'Service',
      serviceType: 'Umzug nach Deutschland - Umzugsfirma Schweiz Deutschland',
      provider: {
        '@type': 'MovingCompany',
        name: 'umzug-schweiz-deutschland.ch',
        telephone: '0800700100',
      },
      areaServed: ['Switzerland', 'Germany'],
      keywords: 'Umzug nach Deutschland, Umzug Schweiz Deutschland, Auswandern nach Deutschland, Umzugsfirma nach Deutschland',
      hasOfferCatalog: {
        '@type': 'OfferCatalog',
        name: 'Umzugsservices nach Deutschland',
        itemListElement: [
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Umzug nach Deutschland Komplettservice',
              description: 'Vollständiger Umzugsservice für Auswandern nach Deutschland: Transport, Verpackung, Zollabwicklung, Montage',
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Zollabwicklung Deutschland',
              description: 'Komplette Abwicklung aller Zollformalitäten beim Umzug Schweiz Deutschland',
            },
          },
          {
            '@type': 'Offer',
            itemOffered: {
              '@type': 'Service',
              name: 'Möbelmontage Deutschland',
              description: 'Professionelle Montage und Demontage bei Umzug nach Deutschland',
            },
          },
        ],
      },
    };

    const script4 = document.createElement('script');
    script4.type = 'application/ld+json';
    script4.text = JSON.stringify(serviceSchema);
    document.head.appendChild(script4);

    const breadcrumbSchema = {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        {
          '@type': 'ListItem',
          position: 1,
          name: 'Home',
          item: 'https://umzug-schweiz-deutschland.ch',
        },
        {
          '@type': 'ListItem',
          position: 2,
          name: 'Services',
          item: 'https://umzug-schweiz-deutschland.ch#services',
        },
        {
          '@type': 'ListItem',
          position: 3,
          name: 'Preise',
          item: 'https://umzug-schweiz-deutschland.ch#preise',
        },
        {
          '@type': 'ListItem',
          position: 4,
          name: 'Kontakt',
          item: 'https://umzug-schweiz-deutschland.ch#kontakt',
        },
      ],
    };

    const script5 = document.createElement('script');
    script5.type = 'application/ld+json';
    script5.text = JSON.stringify(breadcrumbSchema);
    document.head.appendChild(script5);

    return () => {
      document.head.removeChild(script1);
      document.head.removeChild(script2);
      document.head.removeChild(script3);
      document.head.removeChild(script4);
      document.head.removeChild(script5);
    };
  }, []);

  return null;
}
